<div
  class="flex flex-grow items-start w-full pt-6 pl-8 pr-10 justify-between h-full"
>
  <div class="flex flex-col h-full w-[67%] border-r-white pt-[2%] pl-[3%]">
    <div class="flex flex-row">
      <h2 class="text-lg font-medium text-white">About us</h2>
    </div>
    <div class="mt-7">
      <p class="text-sm w-11/12 font-normal leading-[1.6rem] text-[#EFEDEF]">
        Luminous Power Technologies is a leading provider of solar solutions in
        India. We have been in the solar business since 2008 and have installed
        over 1 million solar systems in India. <br />
        <br />

        We offer a wide range of solar products, including solar panels,
        inverters, batteries, and mounting structures. We also have a team of
        experienced solar engineers who can help customers design and install a
        solar system that meets their specific needs. <br />
        <br />

        We are excited to offer our customers the Luminous solar mobile app.
        This app will allow customers to track their solar generation,
        consumption, power cuts, savings, and more. We believe that the Luminous
        solar mobile app will be a valuable tool for our customers and will help
        them save money, reduce their carbon footprint, and live more
        sustainably.
      </p>

      <div class="flex flex-col mt-10">
        <div>
          <span class="text-white"> Connect with us &#58;</span>
        </div>
        <div class="flex flex-row gap-[26px] mt-5 justify-around w-[130px]">
          <a href="https://www.facebook.com/myluminous/" target="_blank">
            <img
              src="../../../../assets/images/customer_screens/facebook.svg"
              alt="Facebook"
            />
          </a>
          <a
            href="https://www.instagram.com/luminous_officials"
            target="_blank"
          >
            <img
              src="../../../../assets/images/customer_screens/insta.svg"
              alt="Instagram"
            />
          </a>
          <a href="https://twitter.com/myluminous" target="_blank">
            <img
              src="../../../../assets/images/customer_screens/twitter 1.svg"
              alt=" Twitter "
            />
          </a>
          <a
            href="https://www.youtube.com/channel/UCw6k_Tm3O0MI23ah2SBYB3Q"
            target="_blank"
          >
            <img
              src="../../../../assets/images/customer_screens/youtube.svg"
              alt="Youtube"
            />
          </a>
        </div>
      </div>
    </div>
  </div>
  <div class="h-full bg-white w-[0.0045%] opacity-[0.05] mr-16"></div>
  <div
    class="flex flex-col second-part overflow-auto h-full w-[30%] md:pr-5 pt-[2%] lg:pr-10 xl:pr-14 text-white"
  >
    <div class="text-lg font-semibold text-dark-font-heading">
      <p class="text-lg font-medium">Blogs</p>
    </div>
    <div class="mt-10">
      @if (exploreList.length > 0) {
        <div class="w-full cursor-pointer" (appClickableDirective)="openLink(exploreList[0])">
          <div class="w-full relative h-32">
            <img
              class="rounded-2xl object-cover"
              [ngSrc]="exploreList[0].image"
              alt="Post"
              fill
              priority
            />
          </div>
          <div class="mt-2.5">
            <p
              class="text-white font-normal text-base text-wrap p-2 line-clamp-2"
            >
              {{ exploreList[0].title }}
            </p>
          </div>
          <div class="flex flex-row w-full ml-2 text-sm opacity-50">
            <div>
              <span class="text-[14.2px] font-medium text-[#94989E]">{{
                exploreList[0].date * 1000 | date: "dd/MM/yyyy hh:mm:ss a"
              }}</span>
            </div>
            <div class="h-7 w-[0.1%] ml-[4%] bg-[#94989E]"></div>
            <div class="ml-[4%] text-[#94989E]"><span>New</span></div>
          </div>
        </div>
      }
    </div>
    <div class="w-full flex-grow h-[16.5rem]">
      <div class="grid gap-1 mt-3 w-full h-full max-w-full flex-grow cardrow">
        @for (item of exploreList; track $index) {
          <div
            class="flex flex-row card w-[100%] h-[7rem] items-center p-2.5 overflow-hidden align-middle text-xs cursor-pointer"
            (appClickableDirective)="openLink(item)"
          >
            <div class="h-[5rem] w-[5rem] flex-shrink-0 flex items-center justify-center relative rounded-lg overflow-hidden">
              <img
                [ngSrc]="item.image"
                alt="post"
                class="rounded-lg object-cover w-full h-full"
                fill
              />
            </div>
            <div class="flex flex-col ml-3.5">
              <div class="text-xs font-normal leading-5 text-white">
                <span>{{ item.title }}</span>
              </div>
              <div class="mt-1.5">
                <span
                  class="text-[11px] font-light text-[#AEAEAE] leading-4 line-clamp-2"
                  >{{ item.description }}</span
                >
              </div>
              <div class="mt-2">
                <span class="text-[10px] font-light text-white">{{
                  item.date * 1000 | date: "dd/MM/yyyy hh:mm:ss a"
                }}</span>
              </div>
            </div>
          </div>
          <div class="w-full bg-white h-[0.01rem] opacity-5"></div>
        }
      </div>
    </div>
  </div>
</div>
